import logger from '@utils/logger';
import { useBatchSwapAssortmentAcrossZoneMutation } from '@graphql/generated/graphql';

const useBatchSwapAssortmentAcrossZone = () => {
  const { mutate, mutateAsync, isError, isLoading, isSuccess, data } = useBatchSwapAssortmentAcrossZoneMutation({
    onError: (error) => {
      let loggedError: Error = Error('batchSwapAssortmentAcrossZone failed');
      if (error instanceof Error) {
        loggedError = error;
      }
      void logger.error('Call to batchSwapAssortmentAcrossZone resulted in error', loggedError);
    },
    onSuccess: (response) => {
      const { errorMap } = response.batchSwapAssortmentAcrossZone;
      if (errorMap.length !== 0) {
        void logger.error('Call to batchSwapAssortmentAcrossZone resulted in error');
      }
    },
  });
  const { errorMap } = data?.batchSwapAssortmentAcrossZone ?? {};
  return {
    mutate,
    mutateAsync,
    isLoading,
    isError: isError || !!errorMap,
    isSuccess,
    errorMap,
  };
};

export default useBatchSwapAssortmentAcrossZone;
